import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Specialist Roles\n          ")
], -1);
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "*If yes, the word mobile should be included in the job title.", -1);
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "*Please check with your HR Manager whether Hybrid Working applies; if so, this will be noted in the job offer.", -1);
const _hoisted_10 = ["innerHTML"];
import { Input } from '@/form';
export default /*#__PURE__*/ _defineComponent({
    __name: 'specialistRoles',
    props: {
        formData: {},
        disableForm: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const highway_role = Input('Is this a Highway Worker Role? * ', 'highway_role', 'text', props.disableForm, props.formData.highwayWorker);
        const mobile_role = Input('Is this a Mobile Worker Role? * ', 'mobile_role', 'text', props.disableForm, props.formData.mobileWorker);
        const hybrid_role = Input('Will the employee be a Hybrid Worker? * ', 'hybrid_role', 'text', props.disableForm, props.formData.hybridWorker);
        const collective_bargaining = Input('Will the employee be subject to Collective Bargaining, if so please provide the name of the Collective Bargaining Arrangement as this will be included in their Contract of Employment:', 'hybrid_role', 'text', props.disableForm, props.formData.collectiveBargaining);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(highway_role) }, null, 8, _hoisted_5),
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(mobile_role) }, null, 8, _hoisted_6),
                        _createTextVNode(),
                        _hoisted_7,
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(hybrid_role) }, null, 8, _hoisted_8),
                        _createTextVNode(),
                        _hoisted_9,
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(collective_bargaining) }, null, 8, _hoisted_10)
                    ])
                ])
            ]));
        };
    }
});
